import React, { useState, useEffect } from 'react';
import Popup from './Popup';  // Adjust the import if necessary
import { Button } from '@material-ui/core';

const HostingRedirectPopup = () => {
    const [openPopup, setOpenPopup] = useState(false);

    useEffect(() => {
        const oldUrl = 'https://kaipsoolretail.web.app'; // Replace with your old URL
        const currentUrl = window.location.href;

        if (currentUrl.includes(oldUrl)) {
            setOpenPopup(true);
        }
    }, []);

    const handleRedirect = () => {
        setOpenPopup(false);
        window.location.replace('https://kaipsool.com');
    };

    return (
        <div>
            {openPopup && (
                <Popup openPopup={openPopup} setOpenPopup={setOpenPopup} title="Website Moved">
                    <div>
                        <h3>We have moved to a new hosting!</h3>
                        <p>You are visiting the old URL. Please be aware that we have now moved to a new hosting setup. You will be redirected shortly.</p>
                        <Button
                            variant="contained"
                            className="employerIndex__createPostBtn employerIndex__createProduct" onClick={handleRedirect}>Go to New URL</Button>
                    </div>
                </Popup>
            )}
        </div>
    );
};

export default HostingRedirectPopup;
